import {
  FormControlLabel,
  Checkbox,
  TextField,
  Box,
  Card,
  Button,
} from '@mui/material';
import React, { useState } from 'react';
import YouTube from 'react-youtube';
import WarningIcon from '@mui/icons-material/Warning';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { YouTubeVideo } from '../@types/api';

const opts = {
  height: '177',
  width: '100%',
  playerVars: {
    autoplay: 0,
    modestbranding: 1,
    showinfo: 0,
    rel: 0,
  },
};

interface Props {
  video: YouTubeVideo;
  onSaveVideo: (video: YouTubeVideo) => void;
  isSelected: boolean;
  onReady: (event: any) => void;
}
const YouTubeVideoCard: React.FC<Props> = ({
  video,
  onSaveVideo,
  isSelected,
  onReady,
}) => {
  const [orderIndex, setOrderIndex] = useState<number>(video.orderIndex);
  const [isLive, setIsLive] = useState<boolean>(video.isLive);
  const [shouldDelete, setShouldDelete] = useState<boolean>(false);
  const isDirty =
    shouldDelete || orderIndex !== video.orderIndex || isLive !== video.isLive;

  const handleSave = () => {
    const updatedVideo = {
      ...video,
      isLive,
      orderIndex,
    };
    onSaveVideo(updatedVideo);
  };

  const handleReset = () => {
    setIsLive(video.isLive);
    setOrderIndex(video.orderIndex);
    setShouldDelete(false);
  };

  return (
    <>
      <Card raised={isSelected}>
        <Box>
          <YouTube
            videoId={video.upload?.fileName}
            opts={opts}
            onReady={onReady}
          />
        </Box>

        <Box
          justifyContent='space-between'
          display='flex'
          alignItems='center'
          sx={{ width: '100%', p: 1 }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isLive}
                onChange={() => setIsLive(!isLive)}
                disabled={!isSelected}
              />
            }
            label='Live'
          />
          <TextField
            label='Order'
            disabled={!isSelected}
            type='number'
            variant='outlined'
            value={orderIndex}
            onChange={(e) => setOrderIndex(Number(e.currentTarget.value))}
            InputProps={{ inputProps: { min: 0 } }}
            size='small'
            sx={{ maxWidth: 60 }}
          />
        </Box>

        <Box
          justifyContent='space-between'
          display='flex'
          alignItems='center'
          sx={{ width: '100%' }}
        >
          <Button
            aria-label='cancel'
            onClick={handleReset}
            disabled={!isDirty}
            title='cancel'
            startIcon={
              <CancelIcon color={isDirty ? 'secondary' : 'disabled'} />
            }
          >
            Undo
          </Button>
          {isDirty && <WarningIcon color='warning' />}
          <Button
            aria-label='save'
            onClick={handleSave}
            title='save changes'
            startIcon={<SaveIcon color={isDirty ? 'action' : 'disabled'} />}
          >
            Save
          </Button>
        </Box>
      </Card>
    </>
  );
};

export default YouTubeVideoCard;
